'use client';

import { useEffect } from 'react';

export default function DynamicFavicon({ iconUrl }) {
	useEffect(() => {
		const link = document.querySelector("link[rel~='icon']");
		if (link) {
			link.href = iconUrl;
		} else {
			const newLink = document.createElement('link');
			newLink.rel = 'icon';
			newLink.href = iconUrl;
			document.head.appendChild(newLink);
		}
	}, [iconUrl]);

	return null; // This component doesn't render anything
}
